import Lottie from 'lottie-react';

import lottieActivity from '../jsons/activity-empty.json';

const LottieActivityEmpty = props => {
  return <Lottie animationData={lottieActivity} loop={false} {...props} />;
};

export default LottieActivityEmpty;
